import { Link } from "react-router-dom";

const styles = {
  yellow: "bg-yellow text-navy",
  sky: "bg-sky text-navy",
  coral: "bg-coral text-navy",
  navy: "bg-navy text-cream",
  white: "bg-white text-navy",
};

export const Btn = ({ to, href, children, variant = "yellow", className = "", testid, onClick, type }) => {
  const cls = `inline-flex items-center justify-center gap-2 border-2 border-navy px-7 py-3.5 rounded-full font-body font-bold text-base md:text-lg shadow-brutal hover:-translate-y-1 hover:shadow-brutal-lg active:translate-y-0 transition-[transform,box-shadow] duration-200 ${styles[variant]} ${className}`;
  if (to) return <Link to={to} data-testid={testid} className={cls} onClick={onClick}>{children}</Link>;
  if (href) {
    const external = href.startsWith("http");
    return <a href={href} data-testid={testid} className={cls} onClick={onClick} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{children}</a>;
  }
  return <button type={type || "button"} data-testid={testid} className={cls} onClick={onClick}>{children}</button>;
};
